import { useNavigate } from "react-router-dom";


import FileDownloadIcon from '@mui/icons-material/FileDownload';
import SearchBar from "../../components/SearchBar";
import { useState } from "react";
import { Button } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import ReadyMadeYoghurtList from "../../features/readymadeyoghurt/readyMageYoghurtList";

const ManageReadyMadeYoghurt = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <>
      <div className="main_title">
        <h1>Manage Ready Made Yoghurts</h1>
        <p>
          <button
            onClick={() => navigate("/dashboard")}
          >
            Dashboard
          </button>{" "}
          - Manage Ready Made Yoghurts
        </p>
      </div>
      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </div>
          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => navigate('/manage-readymade-yoghurt/add')}><AddIcon /> Add  Ready Made Yoghurts</Button>
              <Button className="btn btn_black"><FileDownloadIcon /> Export CSV</Button>
          </div>
        </div>
        <ReadyMadeYoghurtList />
      </div>
    </>
  );
};

export default ManageReadyMadeYoghurt;
